import { useHistory } from "react-router-dom";
import { Badge, Text } from "@merge-api/merge-javascript-shared";
import { Integration } from "../../../../models/Entities";
import { AvatarSize, IntegrationAvatar } from "../../../shared/MergeAvatars";
import { getBlueprintsPath, navigateHelper } from "../../../../router/RouterUtils";
import { isCategoryStatusBeta, isCategoryStatusDraft } from "../utils/categoryStatus";

type Props = {
  integration: Integration;
};

const IntegrationsDashboardGridCard = ({ integration }: Props) => {
  // hooks
  const history = useHistory();

  // derived state
  const isBeta = (integration.categories_status_info ?? []).some(isCategoryStatusBeta);
  const isDraft = !isBeta && (integration.categories_status_info ?? []).some(isCategoryStatusDraft);

  // event handlers
  const onClick = (event: React.MouseEvent<HTMLDivElement>) => {
    navigateHelper(history, getBlueprintsPath(integration.id), event.metaKey || event.ctrlKey);
  };

  // render
  return (
    <div
      className="flex w-32 cursor-pointer flex-col items-center gap-2 transition-transform hover:scale-105"
      onClick={onClick}
    >
      {/* The child selector overrides the avatar's own size classes without !important */}
      <div className="relative [&>div]:h-32 [&>div]:w-32">
        <IntegrationAvatar integration={integration} size={AvatarSize.xxl} />
        {isBeta && (
          <Badge size="md" color="purple" className="absolute -bottom-1 -right-1">
            Beta
          </Badge>
        )}
        {isDraft && (
          <Badge size="md" color="gray" className="absolute -bottom-1 -right-1">
            Draft
          </Badge>
        )}
      </div>
      <Text variant="sm" className="text-center">
        {integration.name}
      </Text>
      {/* Active, non-test, fully linked accounts that do not need a relink */}
      <Text variant="sm" className="text-center text-gray-40">
        Linked Accounts: {integration.number_of_linked_accounts ?? 0}
      </Text>
    </div>
  );
};

export default IntegrationsDashboardGridCard;
